import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './supplyDeliveriesModuleConfig';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface SupplyDeliveryLine {
  id?: number;
  caseId?: number | null;
  itemId?: number | null;
  itemVcode?: string | null;
  itemDescription?: string | null;
  unitId?: number | null;
  purchaseOrderQty?: number | null;
  deliveryQty?: number | null;
  isDelivered?: boolean;
  itemNotes?: string | null;
  item?: {
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
  } | null;
  unit?: { id?: number; ucode?: string | null; descr?: string | null } | null;
}

export interface SupplyDelivery {
  id: number;
  vesselId: number;
  dlvDate?: string | null;
  ref?: string | null;
  supplierId: number;
  portCode?: number | null;
  deliveryDate?: string | null;
  purchaseOrderId?: number | null;
  caseId: number;
  refN?: number | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  lines?: SupplyDeliveryLine[];
  _count?: { lines: number };
  supplyCase?: { id: number; ref?: string | null; caseDate?: string | null; eta?: string | null } | null;
  vessel?: { id: number; vesselName?: string | null; vesselAbrv?: string | null; imoNumber?: string | null } | null;
  order?: {
    id: number;
    ref?: string | null;
    orderDate?: string | null;
    quotationId?: number | null;
    exchangeRate?: string | number | null;
    lineItems?: { lineTotal?: string | number | null }[];
    expenses?: { value?: string | number | null; vat?: string | number | null }[];
    quotation?: { id: number; ref?: string | null } | null;
  } | null;
  port?: { id: number; name: string; code?: string | null } | null;
  supplier?: { id: number; name: string; code?: string | null; email?: string | null; isActive?: boolean } | null;
}

export const useSupplyDeliveries = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<SupplyDelivery> | SupplyDelivery[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<SupplyDelivery>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSupplyDelivery = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<SupplyDelivery>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
